import { useStaticQuery } from "gatsby";
export var useActivePopup = function useActivePopup() {
    var _useStaticQuery = useStaticQuery("826177454"), allDatoCmsPopup = _useStaticQuery.allDatoCmsPopup;
    return allDatoCmsPopup.nodes && allDatoCmsPopup.nodes.length > 0 ? allDatoCmsPopup.nodes[0] : undefined;
};
